import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { LabelAdmin, LabelTopUser, LabelVerifiedAccount } from 'global/Labels';
import { UserGraph } from '../../../../../@types/user';

interface UsernameProps {
  user: UserGraph;
}

function Username({ user }: UsernameProps) {
  return (
    <Flex align="center">
      <Text size="16px" weight="bold">
        {user?.profile?.username}
      </Text>
      <LabelVerifiedAccount
        deprecatedVerifiedStatus={user?.badge?.is_verified}
        verifiedStatus={user?.badge?.verified_status}
      />
      {user?.badge?.is_top && <LabelTopUser />}
      {user?.badge?.is_admin && <LabelAdmin privilege={1} />}
    </Flex>
  );
}

export default Username;
